import { Portals } from '../../../types';

import { useGetClientInformation } from './index';

export const useIsBTobEnabled = () => {
  const { clientInformation } = useGetClientInformation();

  return clientInformation?.enablePortals?.includes(Portals.BTOB);
};
